<!--
 * @Description: 
 * @Author: 
 * @Date: 2024-02-24 18:08:34
-->
<template>
    <el-container class="user-menu-shell">
        <el-aside :width="asideWidth">
            <div class="person-title">
                 个人中心
            </div>
            <el-menu
                :default-active="$route.path"
                class="el-menu-vertical-demo"
                :router="true"
            >
                <el-menu-item
                    :index="item.path"
                    v-for="item in menuList"
                    :key="item.id"
                >
                    <i :class="item.icon" style="font-size: 30px"> </i>
                    <b style="font-size: 22px"> {{ item.name }}</b>
                </el-menu-item>
            </el-menu>
        </el-aside>
        <el-main>
            <router-view></router-view>
        </el-main>
    </el-container>
</template>
<script>
export default {
    name: "UserMenu",
    data() {
        return {
            url: "",
            viewportWidth:
                typeof window === "undefined" ? 1024 : window.innerWidth,
            menuList: [
                {
                    id: 1,
                    name: "基本信息",
                    path: "/user",
                    icon: "iconfont icon-r-paper",
                },
                {
                    id: 2,
                    name: "我的订单",
                    path: "/bill",
                    icon: "iconfont icon-r-shield",
                },
            ],
        };
    },
    computed: {
        asideWidth() {
            return this.$platform.isMobile && this.viewportWidth <= 768
                ? "100%"
                : "200px";
        },
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.viewportWidth = window.innerWidth;
        },
    },
};
</script>

<style scoped>
.el-container {
    border: 1px solid #e1e1e1;
    width: 1200px;
    margin: 0 auto;
}
.person-title {
    margin: 5px 5px 5px 20px; 
    font-size: 26px;
}
.el-aside h1 {
    margin-left: 25%;
    font-size: 24px;
}

@media (max-width: 1023px) {
    .el-container {
        width: auto;
        margin: 0 24px;
    }
}

@media (max-width: 768px) {
    #app.is-mobile-layout .user-menu-shell {
        width: auto;
        margin: 0;
        border-left: 0;
        border-right: 0;
        flex-direction: column;
    }

    #app.is-mobile-layout .user-menu-shell .person-title {
        margin: 16px;
        font-size: 22px;
    }

    #app.is-mobile-layout .user-menu-shell .el-menu-vertical-demo {
        display: flex;
        overflow-x: auto;
    }
}
</style>
